import { combineReducers } from '@reduxjs/toolkit';
import global from './global';
import image from "@reducers/image";
var rootReducer = combineReducers({
    global: global, image: image
});
export default rootReducer;
